import { useEffect, useState } from 'react';

// Some mobile WebKit/Chromium builds have historically misreported the
// `hover` media feature as matching even on touchscreens (to keep :hover-only
// sites usable via tap). Cross-checking against touch capability keeps the
// custom cursor and hover-tilt effects reliably off on phones/tablets.
const detectFinePointer = () => {
  if (typeof window === 'undefined') return false;
  const hasTouch = navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
  const matchesFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  return matchesFinePointer && !hasTouch;
};

export const useIsFinePointer = (): boolean => {
  const [isFinePointer, setIsFinePointer] = useState(detectFinePointer);

  useEffect(() => {
    const query = window.matchMedia('(hover: hover) and (pointer: fine)');
    const update = () => setIsFinePointer(detectFinePointer());
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);

  return isFinePointer;
};
